import { render } from "./Micro-learning.vue?vue&type=template&id=6372bef0&scoped=true"
import script from "./Micro-learning.vue?vue&type=script&lang=js"
export * from "./Micro-learning.vue?vue&type=script&lang=js"

import "./Micro-learning.vue?vue&type=style&index=0&id=6372bef0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6372bef0"]])

export default __exports__